module.exports = __webpack_public_path__ + "img/small-strelki.774ef226.png";